import flutterIcon from '@assets/images/cross-platform-mobile-app-development/flutter-icon.avif'
import IoTAndHardwareAppIcon from '@assets/images/cross-platform-mobile-app-development/IoT-and-hardware-app-icon.avif'
import kotlinMultiplatformIcon from '@assets/images/cross-platform-mobile-app-development/kotlin-multiplatform-icon.avif'
import MVPDevelopmentIcon from '@assets/images/cross-platform-mobile-app-development/MVP-development-icon.avif'
import reactNativeIcon from '@assets/images/cross-platform-mobile-app-development/react-native-icon.avif'




export const industriesWeEmpower = [
    {heading :"MVP Development", text:'Validate your business model quickly with cost-effective prototypes designed for immediate market feedback.',img:MVPDevelopmentIcon,},
    {heading :"React Native Solutions", text:'Scalable apps built with JavaScript, allowing for deep integration with extensive web ecosystems and existing libraries.',img:reactNativeIcon},
    {heading :"Flutter Development", text:'We create pixel-perfect, high-performance UIs using Dart and the Skia/Impeller rendering engines.',img:flutterIcon},
    {heading :"Kotlin Multiplatform (KMP)", text:'The future-proof choice for sharing critical business logic while retaining 100% native UI performance.',img:kotlinMultiplatformIcon},
    {heading :"Complex IoT & Hardware Apps", text:' Specialized engineering for applications requiring Bluetooth (BLE), NFC, or low-latency sensor integration.',img:IoTAndHardwareAppIcon},
   
 
]  
